import React from "react";
import "./SupportView.scss";
import {getTranslate, Translate, TranslateFunction} from "react-localize-redux";
import {useSelector} from "react-redux";
import {Nullable} from "@data-force/app";
import StoreState from "../../interfaces/store/storeState";
import {formatString, getHistoryParams} from "../../utils/common";
import HistoryParams from "../../interfaces/historyParams";
import {MAIL_LINK, Routes} from "../../utils/constants";

const SupportView: React.FC = (): React.ReactElement => {
    const translatePath: string = "pages.SupportView.SupportView";
    const translate: TranslateFunction = useSelector(({localize}: StoreState) => getTranslate(localize));

    const historyParams: Nullable<HistoryParams> = getHistoryParams();
    const faqUrl: string = `#/${historyParams?.idpId}/${Routes.FAQ}`;
    const template: string = translate(`${translatePath}.paragraph1.text`) as string;
    const faqTxt: string = translate(`${translatePath}.faqs.text`) as string;
    const supportTeamTxt: string = translate(`${translatePath}.supportTeam.text`) as string;
    const formattedParagraph: string = formatString(
        template, `<a href=${faqUrl}>`, faqTxt, "</a>", `<a href=mailto:${MAIL_LINK}>`, supportTeamTxt, "</a>",
    );

    return (
        <div className="df-support-container">
            <div className="df-support-decorative"/>
            <div className="df-support-content">
                <h3 className="df-support-header"><Translate id={`${translatePath}.headerTxt.text`}/></h3>
                <p dangerouslySetInnerHTML={{__html: formattedParagraph}}/>
                <p><Translate id={`${translatePath}.paragraph2.text`}/></p>
            </div>

        </div>
    );
};

export default SupportView;
